// hooks/useTourGeneration.js
import { useState } from 'react';
import axios from 'axios';
import { DEFAULT_AI_MODEL } from '../constants/aiConstants';

export const useTourGeneration = (apiKey) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [isGeneratingStop, setIsGeneratingStop] = useState(null);
  const [error, setError] = useState(null);

  const generateTourPlan = async (prompt, aiModel = null) => {
    // Use the provided model or fall back to default
    const modelToUse = aiModel || DEFAULT_AI_MODEL;
    
    try {
      setIsGenerating(true);
      setError(null);
      
      console.log(`Generating tour plan with model: ${modelToUse}`);

      const response = await axios.post(
        'https://api.openai.com/v1/chat/completions',
        {
          model: modelToUse,
          messages: [
            {
              role: "system",
              content: "You are an expert tour guide with deep knowledge of history, culture, and local traditions. Provide detailed, accurate, and engaging tour information. Focus on creating immersive experiences while maintaining historical accuracy."
            },
            {
              role: "user",
              content: prompt
            }
          ],
          temperature: 0.7,
          max_tokens: 2000
        },
        {
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json'
          }
        }
      );

      const content = response.data?.choices?.[0]?.message?.content;
      if (!content) {
        throw new Error('No content received from API');
      }

      return content;
    } catch (error) {
      console.error('Error generating tour plan:', error);
      setError(error.message);
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  const generateStopDetail = async (prompt, stopNumber, aiModel = null) => {
    // Use the provided model or fall back to default
    const modelToUse = aiModel || DEFAULT_AI_MODEL;
    
    try {
      setIsGeneratingStop(stopNumber);
      setError(null);
      
      console.log(`Generating stop detail with model: ${modelToUse}`);

      const response = await axios.post(
        'https://api.openai.com/v1/chat/completions',
        {
          model: modelToUse,
          messages: [
            {
              role: "system",
              content: "You are an expert tour guide with deep knowledge of history, culture, and local traditions. Provide detailed, accurate, and engaging descriptions of specific locations. Focus on creating immersive experiences while maintaining historical accuracy."
            },
            {
              role: "user",
              content: prompt
            }
          ],
          temperature: 0.7,
          max_tokens: 2000
        },
        {
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json'
          }
        }
      );

      const content = response.data?.choices?.[0]?.message?.content;
      if (!content) {
        throw new Error('No content received from API');
      }

      return content;
    } catch (error) {
      console.error('Error generating stop detail:', error);
      setError(error.message);
      throw error;
    } finally {
      setIsGeneratingStop(null);
    }
  };

  return {
    generateTourPlan,
    generateStopDetail,
    isGenerating,
    setIsGenerating, 
    isGeneratingStop,
    setIsGeneratingStop,
    error
  };
};